// extracted by mini-css-extract-plugin
module.exports = {"small-mobile":"350px","mobile":"400px","tablet":"700px","small-desktop":"900px","desktop":"1200px"};